import { Atom } from 'AppReact';
import styled from "styled-components";

const template = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #FD2020;
`;

export default Atom({ type: 'label', dataType: 'string', template })